import {Order} from "../../types";

export function getPaymentsTotal(order: Order): string {
    const total = order.payments.reduce((total, payment) => {
        return total + payment.amount;
    }, 0);
    return total.toFixed(2);
}